import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * Search Services
 *
 */
export const searchService = (http, cookies) => ({
  /**
   * Search article
   *
   * @param {object} params object
   * @param {number} params.query search query
   * @param {number} [params.page] page optional
   * @param {number} [params.limit] limit optional
   */
  async searchArticle({ query, page = 1, limit = 24, sort, categoryId, duration, withFacets = true, mainCategoriesOnly = true } = {}) {
    const queryParams = encodeQuery({ q: query, page, limit, sort, categoryId, duration, withFacets, mainCategoriesOnly });
    const { data: result } = await http.get(`${base}/search/article${queryParams}`);

    return result;
  },

  /**
   * Search user
   *
   * @param {object} params object
   * @param {number} params.query search query
   * @param {number} [params.page] page optional
   * @param {number} [params.limit] limit optional
   */
  async searchUser({ query, page = 1, limit = 40 } = {}) {
    const queryParams = encodeQuery({ q: query, page, limit });
    const { data: result } = await http.get(`${base}/search/user${queryParams}`);

    return result;
  },

  /**
   * Search tag
   *
   * @param {object} params object
   * @param {number} params.query search query
   * @param {number} [params.page] page optional
   * @param {number} [params.limit] limit optional
   */
  async searchTag({ query, page = 1, limit = 25 } = {}) {
    const queryParams = encodeQuery({ q: query, page, limit });
    const { data: result } = await http.get(`${base}/search/tag${queryParams}`);

    return result;
  },

  /**
   * Search location
   *
   * @param {object} params object
   * @param {number} params.query search query
   */
  async searchLocation({ city } = {}) {
    const { data: result } = await http.get(
      `https://nominatim.openstreetmap.org/search.php?q=${city}&accept-language=tr-TR&format=json&limit=5&extratags=1`
    );
    return result.filter((item) => item.addresstype === 'state' || item.addresstype === 'city');
  },
});
